import { deleteAdminTeamMember } from '../../../shared/api/team.services';
import toast from '../../../shared/lib/toast';

export const patchClick = (id, navigate) => {
  navigate(`/team-rewrite/${id}`);
};

export const deleteTeamClick = async (memberId, onSuccessRefresh) => {
  if (window.confirm('Ви впевнені, що хочете видалити цього учасника команди?')) {
    const response = await deleteAdminTeamMember(memberId);

    if (!response?.error) {
      if (onSuccessRefresh) onSuccessRefresh();
    } else {
      toast.error(response.message || 'Помилка при видаленні учасника.');
    }
  }
};
